export default __webpack_public_path__ + "static/media/user-role.53ee0b82.svg";